import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { ClassroomsCreateTeachersSelectPage } from '../classrooms-create/classrooms-create-teachers-select/classrooms-create-teachers-select';
import { ClassroomsViewPage } from '../classrooms-view/classrooms-view';
import { HomePrincipalPage } from '../home-principal/home-principal';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-classrooms-list',
  templateUrl: 'classrooms-list.html',
})
export class ClassroomsListPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public http: HttpClient,
    public schoolServices: SchoolServices,
    public translate: TranslateService) {

  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-cursos')
    });
    loadingPopup.present();
    this.schoolServices.getClassrooms(this.globals.school_uid);
    loadingPopup.dismiss();

  }

  onBack() {
    this.navCtrl.setRoot(HomePrincipalPage);
  }

  openClassroomCreate() {
    this.navCtrl.push(ClassroomsCreateTeachersSelectPage);
  }

  openClassroomView(classroom) {
    this.navCtrl.push(ClassroomsViewPage, {
      classroom: classroom,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-list/classrooms-list.ts